import { AssignedJob } from "@/models/assignedJob.model";
import { jobService } from "../../services/job.service";
import store from '../store';
import { Job, JobEvent } from '@/models/job.model';

import Vue from "vue";
import { companyService } from '@/services/company.service';
import { JobCommand, Action } from '@/models/app.model';
import { faCommentSlash } from '@fortawesome/free-solid-svg-icons';


const vm = new Vue();

// tslint:disable-next-line:typedef
const state = {
    jobsOnPinBoard: JSON.parse(localStorage.getItem("jobsOnPinBoard") as string) || [] as AssignedJob[],
    jobModalVisibility: false as boolean,
    jobToEdit: 0 as number,
    jobAction: Action.new as Action,
    createJobOnCardId: undefined as number | undefined,
    jobEvents: [] as JobEvent[]
};

// tslint:disable-next-line:typedef
const getters = {
    currentJobsByCardId: (jobState: any) => (cardId: number) => {
        return (jobState.jobsOnPinBoard as AssignedJob[]).filter((j) => j.cardId === cardId);
    },
    // currentAssignedJobsByUserId:(jobState: any) => (userId:number) => {
    //     // tslint:disable-next-line:typedef
    //     let templist = jobState.assignedJobs as AssignedJob[];
    //     return templist.filter(j => j.userId === userId);

    // },
    jobModalVisibility: (jobState: any) => jobState.jobModalVisibility,
    jobToEdit: (jobState: any) => jobState.jobToEdit,
    jobAction: (jobState: any) => jobState.jobAction,
    createJobOnCardId: (jobState: any) => jobState.createJobOnCardId,
    currentAssignedJobs: (jobState: any) => jobState.jobsOnPinBoard,
    getJobNumber: (jobState: any) => jobState.jobsOnPinBoard.length,
    getJobDoneNumber: (jobState: any) => {
        // tslint:disable-next-line:typedef
        return (jobState.jobsOnPinBoard as AssignedJob[]).filter(j => j.done).length;
    },
    getJobRemainingNumber: (jobState: any) => {
        // tslint:disable-next-line:typedef
        return (jobState.jobsOnPinBoard as AssignedJob[]).filter(j => !j.done).length;
    },
    jobEvents: (jobState: any) => jobState.jobEvents,
};

// tslint:disable-next-line:typedef
const actions = {
    createJob: async ({ commit, dispatch }: { commit: any, dispatch: any }, createJobCommand: any) => {
        let result = await jobService.create(createJobCommand.job);
        if (result) {
            createJobCommand.job.id = result.data;
            vm.$notify({
                group: "message",
                title: "Succe!",
                text: "Jobb skapat",
                duration: 5000,
                type: "success",
            });
            if (createJobCommand.addedFrom === "pinboard") {
                await dispatch("getJobsOnPinBoard", createJobCommand.job.pinBoardId);
            }
            commit("mAddJob", createJobCommand.job);
            return createJobCommand.job.id;
        }
    },
    editJob: async ({ commit, dispatch }: { commit: any, dispatch: any }, command: JobCommand) => {
        if (command.cardId == undefined) {
            command.cardId = undefined;

        }
        // if(store.getters["auth/isAdmin"]){
        commit("mEditJob", command);
        // }
    },
    doneEditJob: async ({ commit, dispatch }: { commit: any, dispatch: any }) => {
        commit("mDoneEditJob");
        await dispatch("getJobsOnPinBoard", store.getters["app/currentPinBoardId"]);
    },
    getJobsOnPinBoard: async ({ commit, dispatch }: { commit: any, dispatch: any }, pinBoardId: number) => {
        const result = await jobService.getJobsOnPinBoard(pinBoardId);
        if (result != null) {
            commit("mSetJobsOnPinBoard", result);
            return true;
        }
        return false;
    },
    getJobsOnPinBoardTomorrow: async ({ commit, dispatch }: { commit: any, dispatch: any }, pinBoardId: number) => {
        const result = await jobService.getJobsOnPinBoardTomorrow(pinBoardId);
        if (result != null) {
            commit("mSetJobsOnPinBoard", result);
            return true;
        }
        return false;
    },
    setJobDone: async ({ commit, dispatch }: { commit: any, dispatch: any }, jobInfo: any) => {
        let result = await jobService.assignedJobDone({ assignedJobId: jobInfo.id, cardId: jobInfo.cardId });
        // console.log(result);
        if (result) {
            commit("mSetJobDone", jobInfo);
        }
    },
    setJobUndo: async ({ commit, dispatch }: { commit: any, dispatch: any }, jobInfo: any) => {
        let result = await jobService.assignedJobUndo({ assignedJobId: jobInfo.id, cardId: jobInfo.cardId });
        // console.log(result);
        if (result) {
            commit("mSetJobDone", jobInfo);
        }

        return true;
    },
    moveJob: async ({ commit, dispatch }: { commit: any, dispatch: any }, jobInfo: any) => {
        commit("mMoveJob", jobInfo);
        let result = await jobService.assignedJobMove({ assignedJobId: jobInfo.id, moveToCardId: jobInfo.cardId });
        if (result) {
            return true;
        }
    },
    removeFromJobEvent: ({ commit, dispatch }: { commit: any, dispatch: any }, pinboardId: number) => {
        commit("mRemoveFromJobEvent", pinboardId);
    },
    addToJobEvent: ({ commit, dispatch }: { commit: any, dispatch: any }, event: JobEvent) => {
        commit("mAddToJobEvent", event);
    }

};

// tslint:disable-next-line:typedef
const mutations = {
    mAddJob: (jobState: any, job: Job) => {
        // console.log(createdJob.jobObject.id);
        // console.log(createdJob.assignedJobIds);
        // // let tmpList = jobState.jobsOnPinBoard as AssignedJob[];
        // job.assignJobTo!.forEach(cardId => {
        // });
        // jobState.jobsOnPinBoard.push(
        // {
        //         id: createdJob.assignedJobIds[0],
        //         name: createdJob.jobObject.name,
        //         jobId: createdJob.jobObject.id,
        //         cardId: createdJob.jobObject.assignJobTo[0]
        // });
        // jobState.jobsOnPinBoard = tmpList;
        // localStorage.setItem("jobsOnPinBoard", JSON.stringify(jobState.jobsOnPinBoard));
    },
    mEditJob: (jobState: any, command: JobCommand) => {
        if (command.cardId) {
            jobState.createJobOnCardId = command.cardId;
        }

        jobState.jobAction = command.action;
        jobState.jobToEdit = command.jobId;
        jobState.jobModalVisibility = true;
    },
    mDoneEditJob: (jobState: any) => {
        jobState.createJobOnCardId = undefined;
        jobState.jobToEdit = 0;
        jobState.jobModalVisibility = false;
    },
    mSetJobsOnPinBoard: (jobState: any, jobs: AssignedJob[]) => {
        localStorage.setItem("jobsOnPinBoard", JSON.stringify(jobs));
        console.log(jobs);
        jobState.jobsOnPinBoard = jobs;
    },
    mSetJobDone: (jobState: any, jobInfo: any) => {
        let tmpList = jobState.jobsOnPinBoard as AssignedJob[];

        tmpList.forEach(element => {
            if (element.id === jobInfo.id) {
                element.done = !!element.done;
            }
        });
        jobState.jobsOnPinBoard = tmpList;
        localStorage.setItem("jobsOnPinBoard", JSON.stringify(tmpList));
    },
    mMoveJob: (jobState: any, jobInfo: any) => {
        // (jobState.jobsOnPinBoard as AssignedJob[]).forEach(job => {
        //     if(job.id === jobInfo.id) {
        //         job.cardId = jobInfo.cardId;
        //     }
        // });

        (jobState.jobsOnPinBoard as AssignedJob[]).find(j => j.id == jobInfo.id)!.cardId = jobInfo.cardId;
        localStorage.setItem("jobsOnPinBoard", JSON.stringify(jobState.jobsOnPinBoard));
    },
    mAddToJobEvent: async (jobState: any, event: JobEvent) => {
        jobState.jobEvents.push(event);
    },
    mRemoveFromJobEvent: async (jobState: any, pinboardId:number) => {
        jobState.jobEvents = jobState.jobEvents.filter((event:JobEvent) => event.pinboardId != pinboardId);
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};